import { MenuItemsType } from 'uikit'
import { ContextApi } from 'contexts/Localization/types'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const config: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [
  // {
  //   label: t('Home'),
  //   icon: 'HomeIcon',
  //   href: '/',
  // },
  // {
  //   label: t('PreSale'),
  //   icon: 'PresaleIcon',
  //   href: '/presale',
  // },
  {
    label: t('Trade'),
    items: [
      {
        label: t('Stats'),
        icon: 'PresaleIcon',
        href: '/stats',
      },
      {
        label: t('Swap'),
        icon: 'ExchangeIcon',
        href: '/swap',
      },
      {
        label: t('LP Maker'),
        icon: 'ZapIcon',
        href: '/zap',
      },
      {
        label: t('Burn DMD'),
        icon: 'NftIcon',
        href: '/burn',
      },
    ],
  },
  {
    label: t('Earn'),
    items: [
      {
        label: t('Farms'),
        icon: 'FarmIcon',
        href: '/farms',
      },
      {
        label: t('Pools'),
        icon: 'PoolIcon',
        href: '/pools',
      },
      {
        label: t('Multi Pool'),
        icon: 'MultiPoolIcon',
        href: '/multi-pool',
      },
      {
        label: t('Vaults'),
        icon: 'VaultsIcon',
        href: '/vaults',
      },
    ],
  },
  {
    label: t('NFTs'),
    items: [
      {
        label: t('My Nfts'),
        icon: 'PresaleIcon',
        href: '/nft/my-nfts',
      },
      {
        label: t('Mint NFTs'),
        icon: 'NewMintsIcon',
        href: '/nft/series',
      },
      {
        label: t('NFT Pools'),
        icon: 'NftPoolsIcon',
        href: '/nft/pools',
      },
      {
        label: t('NFT Multi Sender'),
        icon: 'MultiSenderIcon',
        href: '/nft/multi-sender',
      },
    ],
  },
  {
    label: t('Artists'),
    items: [
      {
        label: t('NFT Launchpad'),
        icon: 'LaunchpadIcon',
        href: '/nft/launchpad',
      },
      {
        label: t('Deploy Collection'),
        icon: 'DevelopIcon',
        href: '/nft/factory',
      },
      {
        label: t('User Panel'),
        icon: 'UserPanelIcon',
        href: '/nft/user-panel',
      },
    ],
  },
  {
    label: t('Wheel'),
    // icon: 'WheelIcon',
    href: '/wheel',
  },
]

export default config
